import React, { useState } from 'react'
import Cookies from 'js-cookie'
import { URL_TERMS_OF_USE, URL_PRIVACY_POLICY } from 'constants/links'
import Icon from 'components/shared/Icon'

const consentCookie = 'cookieconsent_05/18'

const Link = ({ text, url }) => (
  <a
    href={url}
    target='_blank'
    rel='noopener noreferrer'
  >
    {text}
  </a>
)

const CookiePolicy = () => {
  const [dismissed, setDismissed] = useState(Cookies.get(consentCookie)
  )

  const dismiss = () => {
    setDismissed(true)
    Cookies.set(consentCookie, true, { path: '/', expires: 999999 })
  }

  if (dismissed) {
    return null
  }

  return (
    <div className='cookie-policy flex justify-between w-80 w-90-m fixed z60 bottom6 left-50 bg-black white pa6 fs x--50'>
      <p className='pr8 pr7-t'>
        This site uses cookies and other tracking technologies to assist with navigation and to analyse site usage.
        By using this website you agree to our use of cookies. For more information about our use of cookies, please
        see our <Link text='Privacy & Cookies Policy' url={URL_PRIVACY_POLICY} />.
        Your use of this site is also subject to our <Link text='Terms of Use' url={URL_TERMS_OF_USE} />.
      </p>
      <Icon name='icon-close' className='pointer w8 min-w7' onClick={dismiss} />
    </div>
  )
}

export default CookiePolicy
